import { Form, InputGroup } from 'react-bootstrap';

interface InputBoxMoneyProps {
  label: string;
  name: string;
  tabIndex?: number;
  value: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errorFeedback?: any;
  onChange?: any;
  setFieldValue: any;
  onBlur?: any;
  isValid?: any;
  isInvalid?: any;
}

const maskDollarAmount = (value: string) => {
  // Remove all non-numeric characters except for the decimal point
  let onlyNums = value.replace(/[^0-9.]/g, '');

  // Split the string into whole number and decimal parts
  let [whole, decimal] = onlyNums.split('.');

  // Add commas to the whole number part
  whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "");

  // Reassemble the parts
  return decimal ? `${whole}.${decimal}` : whole;
};

export const InputBoxMoney: React.FC<InputBoxMoneyProps> = ({
  label,
  name,
  type = 'text',
  tabIndex,
  placeholder,
  required = false,
  value,
  errorFeedback,
  onChange,
  setFieldValue,
  onBlur,
  isValid,
  isInvalid,
}) => {
  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label>{label}</Form.Label>

      <InputGroup>
        <InputGroup.Text>$</InputGroup.Text>
        <Form.Control
          type={type}
          name={name}
          placeholder={placeholder}
          required={required}
          value={value}
          tabIndex={tabIndex}
          // onChange={onChange}
          onChange={(e) => {
            const maskedValue = maskDollarAmount(e.target.value);
            setFieldValue(name, maskedValue);
          }}
          onBlur={onBlur}
          isValid={isValid}
          isInvalid={isInvalid}
        />
        <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};
